export const OPEN_CONTEXT_MENU = 'OPEN_CONTEXT_MENU';
export const CLOSE_CONTEXT_MENU = 'CLOSE_CONTEXT_MENU';
export const ADD_ITEMS_TO_CONTEXT_MENU_WIDGET = 'Web.PageInterface.v1_0.AddItemsToContextMenuWidgetMethod';
export const UPDATE_ITEMS_TO_CONTEXT_MENU = 'Web.PageInterface.v1_0.UpdateItemsToContextMenuMethod';
